module.exports = __webpack_public_path__ + "static/img/new_qxc.1c8f42d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_qxc.png
// module id = 2yW0
// module chunks = 101